import { Box, HStack, Text } from '@chakra-ui/react';
import { BaseCellOptionProps } from '../types/Cell';

export const DefaultCell = ({
  label,
  bgColor = 'transparent',
  px = 0,
  py = 0,
  labelColor,
  labelWeight = 'regular',
  textStyle = 'body.s.medium',
  textColor = 'text.tertiary',
  borderRadius = 'none',
}: BaseCellOptionProps): React.ReactElement => {
  return (
    <Box>
      <HStack justify="left">
        <Box px={`${px}px`} py={`${py}px`} borderRadius={borderRadius} bg={bgColor}>
          <Text
            textStyle={textStyle}
            fontWeight={labelWeight}
            color={textColor}
            {...(labelColor && { color: labelColor })}
          >
            {label}
          </Text>
        </Box>
      </HStack>
    </Box>
  );
};
